import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AdministrationPage } from './administration.page';
import { AdministrationDesktopPage } from './desktop/administration.desktop.page';
import { AdministrationMobilePage } from './mobile/administration.mobile.page';
import { TranslationModule } from '@app/app-translation.module';
import { HeaderComponentModule } from '@shared/gui/structural-components/header-component/header.component.module';
import { SegmentDesktopModule } from '@beego/ngx-segment';
import { EventTypesComponentModule } from '@internal-components/administration-components/event-type-components/event-types-component/event-types.component.module';
import { LocationsComponentModule } from '@internal-components/administration-components/locations-components/locations-component/locations.component.module';
import { DeviceTypesComponentModule } from '@internal-components/administration-components/device-type-components/device-types-component/device-types.component.module';
import { ClientOriginsComponentModule } from '@internal-components/administration-components/client-origin-components/client-origins-component/client-origins.component.module';
import { QuestionCategoriesComponentModule } from '@internal-components/administration-components/question-category-components/question-categories-component/question-categories.component.module';
import { DigibankAgenciesComponentModule } from '@internal-components/administration-components/digibank-agency-components/digibank-agencies-component/digibank-agencies.component.module';
import { TargetAudiencesComponentModule } from '@internal-components/administration-components/target-audience-components/target-audiences-component/target-audiences.component.module';
import { MessageBoxComponentModule } from '@shared/gui/structural-components/message-box-component/message-box.component.module';
import { CancellationReasonsComponentModule } from '@internal-components/administration-components/cancellation-reason-components/cancellation-reasons-component/cancellation-reasons.component.module';
import { MobileBlockerComponentModule } from '@internal/gui/structural-components/mobile-blocker-component/mobile-blocker-component.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		RouterModule.forChild([
			{
				path: '',
				component: AdministrationPage,
			},
		]),
		TranslationModule,
		HeaderComponentModule,
		SegmentDesktopModule,
		EventTypesComponentModule,
		LocationsComponentModule,
		DeviceTypesComponentModule,
		ClientOriginsComponentModule,
		QuestionCategoriesComponentModule,
		DigibankAgenciesComponentModule,
		TargetAudiencesComponentModule,
		CancellationReasonsComponentModule,
		MessageBoxComponentModule,
		MobileBlockerComponentModule,
	],
	declarations: [AdministrationDesktopPage, AdministrationMobilePage, AdministrationPage],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdministrationPageModule {}
